/**
 * @file paddlex 下载 hooks
 * @author FengGuang(fengguang01@baidu.com)
 */

import {useState, useEffect, useCallback} from 'react';
import {useLatest} from 'react-use';
import {useHistory} from 'react-router';
import {fetchGetDownloadInfo} from '../../../../api/pages/paddlexApi';
import {IHistoryVersionData} from '../../components/history-version-table/types';


interface IDownloads {
    windows?: string;
    mac?: string;
    linux?: string;
}

const usePaddleLabDownloadHooks = () => {
    const history = useHistory();
    const [downloads, setDownloads] = useState<IDownloads>({});
    const [text, setText] = useState<string>('');
    const [changelog, setChangelog] = useState<string>('');
    const [recommendedEnvironment, setRecommendedEnvironment] = useState<string>('');
    const [historyVersion, setHistoryVersion] = useState<IHistoryVersionData[]>([]);


    useEffect(() => {
        const p = new URLSearchParams(window.location.search.slice(1));
        const directdownload = p.get('directdownload');
        if (directdownload === 'win' && downloads.windows) {
            window.location.href = downloads.windows;
        }
        else if (directdownload === 'mac' && downloads.mac) {
            window.location.href = downloads.mac;
        }
        else if (directdownload === 'linux' && downloads.linux) {
            window.location.href = downloads.linux;
        }
    }, [downloads]);

    useEffect(() => {
        (async () => {
            let res;
            try {
                res = await fetchGetDownloadInfo();
            }
            catch (err: any) {
                // ignore
            }
            if (res) {
                const pageData = res.body?.result?.pageData ?? {};
                const downloadLinks = pageData.downloadLinks || {};
                setDownloads({
                    linux: downloadLinks.linux,
                    mac: downloadLinks.mac,
                    windows: downloadLinks.windows
                });
                setText(pageData.content || '');
                setChangelog(pageData.changelog || '');
                setRecommendedEnvironment(pageData.recommendedEnvironment || '');
                const hv: any[] = Array.isArray(pageData.historyVersion) ? pageData.historyVersion : [];
                setHistoryVersion(hv.map((item, index) => ({
                    key: '' + index,
                    date: item.date,
                    linuxUrl: item.linuxUrl,
                    macUrl: item.macUrl,
                    version: item.version,
                    winUrl: item.winUrl,
                    releaseNoteUrl: item.releaseNoteUrl
                })));
            }
        })();
    }, []);

    const historyPushRef = useLatest(history.push);
    const onDownloadClick = useCallback((target: string, link: string) => {
        if (typeof (localStorage) === 'object' && historyPushRef.current) {
            const s = localStorage.getItem('paddlexuserinfosubmit');
            if (!s) {
                historyPushRef.current(`/paddlex/userinfo?directdownload=${target}`);
                window.scrollTo(0, 0);
            }
            else {
                window.location.href = link;
            }
        }
    }, [historyPushRef]);

    return {
        downloads,
        text,
        changelog,
        recommendedEnvironment,
        historyVersion,

        onDownloadClick
    };
};

export default usePaddleLabDownloadHooks;
